<template lang="pug">
  .site-container
    .b-password-recovery-page.empty-page
      ._container.empty-page-container
        AuthPasswordRecoveryForm._content.empty-page-content
        AuthFooter
    YaMetrika
</template>

<script>
import AuthPasswordRecoveryForm from '@/components/AuthPasswordRecoveryForm.vue';
import AuthFooter from '@/components/AuthFooter.vue';
import YaMetrika from '@/components/app/YaMetrika.vue';

export default {
  components: { YaMetrika, AuthPasswordRecoveryForm, AuthFooter },
};
</script>

<style lang="scss" scoped>
.password-recovery-page {
  &__content {
    flex-direction: column;
    padding: 88px 207px 100px 207px;
  }

  @media (max-width: 768px) {
    &__container {
      width: calc(100% - 100px);
      padding: 25px 15px;
    }

    &__content {
      padding: 88px 0 100px;
    }
  }

  @media (max-width: 500px) {
    &__container {
      width: 100%;
    }

    &__content {
      padding: 30px 20px 42px;
    }
  }
}
</style>
